module.exports = __webpack_public_path__ + "img/bc_btn.77ea6175.png";